import { createAction } from "redux-act";
export var blockUi = createAction("block ui");
export var unBlockUi = createAction("un block ui");



//////////////////
// WEBPACK FOOTER
// ./src/containers/BlockUi/ducks/actions.ts
// module id = 201
// module chunks = 0